import { ReactNode } from 'react';
import styles from './StepLayout.module.css';

const StepLayout = ({ children }: { children: ReactNode }) => {
  return <div className={styles.container}>{children}</div>;
};

const Header = ({ children }: { children: ReactNode }) => {
  return <div className={styles.header}>{children}</div>;
};

const Title = ({ children }: { children: ReactNode }) => {
  return <span className={styles.title}>{children}</span>;
};

const Description = ({ children }: { children: ReactNode }) => {
  return <span className={styles.description}>{children}</span>;
};

const Content = ({ children }: { children: ReactNode }) => {
  return <div className={styles.content}>{children}</div>;
};

const Actions = ({ children }: { children: ReactNode }) => {
  return <div className={styles.actions}>{children}</div>;
};

StepLayout.Header = Header;
StepLayout.Title = Title;
StepLayout.Description = Description;
StepLayout.Content = Content;
StepLayout.Actions = Actions;

export default StepLayout;
